import Vue from "vue";
import iView from "iview";
import "iview/dist/styles/iview.css"; // 使用 CSS
import "animate.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { post, get } from "./libs/axios";
import Util from "./libs/util";
import VueDND from "awe-dnd";
import VueAwesomeSwiper from "vue-awesome-swiper";
import VueScroller from "vue-scroller";
import md5 from "js-md5";
import JsEncrypt from "jsencrypt";
// import lottie from 'vue-lottie'
import Scroller from "vue-scroller";
import "swiper/dist/css/swiper.css";
import VueClipboard from "vue-clipboard2";

Vue.use(iView);
Vue.use(VueClipboard);
Vue.use(Scroller);
Vue.use(VueAwesomeSwiper);
Vue.use(VueScroller);
Vue.use(VueDND);
// Vue.use(lottie)
Vue.config.productionTip = false;

//import Vconsole from "vconsole";
//let vConsole = new Vconsole();
//Vue.use(vConsole);

Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.util = Util;
Vue.prototype.$md5 = md5;
Vue.prototype.$jsEncrypt = JsEncrypt;
// 每次保持在头部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
router.onError((err) => {
  // alert(JSON.stringify(err))
  // alert(JSON.stringify(err).indexOf('Loading chunk')>-1)
  // alert(err.indexOf('Loading chunk')>-1)
  const targetPath = router.history.pending.fullPath;
  if (
    JSON.stringify(err).indexOf("Loading chunk") > -1 ||
    err.indexOf("Loading chunk") > -1
  ) {
    router.replace(targetPath);
  }
});
/* eslint-disable */

import {
  Overlay,
  Swipe,
  SwipeItem,
  Picker,
  Popup,
  Field,
  Col,
  Row,
  Toast,
  IndexBar,
  IndexAnchor,
  Cell,
  ActionSheet,
  Area,
  CellGroup,
  List,
  SwipeCell,
  Button,
  Step,
  Steps,
  PullRefresh
} from "vant";
Vue.use(Overlay)
  .use(Swipe)
  .use(SwipeItem)
  .use(Picker)
  .use(Popup)
  .use(Field)
  .use(Col)
  .use(Row)
  .use(Toast)
  .use(IndexBar)
  .use(IndexAnchor)
  .use(Cell)
  .use(ActionSheet)
  .use(Area)
  .use(CellGroup)
  .use(List)
  .use(SwipeCell)
  .use(Button).use(Step).use(Steps).use(PullRefresh);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
